import React, { useState } from 'react';
import Modal from 'react-modal';
import { StripeEnv } from '../../../util/enums';
import { SnapIcon } from '../../SnapIcon';
import { SnapButton } from '../../SnapButton';

Modal.setAppElement('body');

const computePayoutOptions = (
  stripeEnv: StripeEnv,
): { name: string; label: string }[] => {
  const payoutIntervalOptionsRaise = [
    { name: 'daily', label: 'Daily' },
    { name: 'weekly', label: 'Weekly' },
    { name: 'manual', label: 'At the end of the fundraiser' },
  ];

  const payoutIntervalOptionsSponsor = [
    { name: 'daily', label: 'Daily' },
    { name: 'weekly', label: 'Weekly' },
    { name: 'monthly', label: 'Monthly' },
  ];
  const mapperObj = {
    RAISE: payoutIntervalOptionsRaise,
    SPONSOR: payoutIntervalOptionsSponsor,
  };
  return mapperObj[stripeEnv] || payoutIntervalOptionsRaise;
};

function ChangePayoutIntervalModal({
  showHeader,
  isOpen,
  stripeEnv,
  toggle,
  onUpdate,
  onCancel,
  defaultInterval,
}: {
  showHeader: boolean;
  isOpen: boolean;
  stripeEnv: StripeEnv;
  defaultInterval?: string;
  toggle: () => void;
  onUpdate: (payoutIntervalSelected: string) => void;
  onCancel: () => void;
}): React.JSX.Element {
  const [payoutInterval, setPayoutInterval] = useState<string | undefined>(
    defaultInterval,
  );
  return (
    <Modal
      className='fixed inset-0 flex items-center justify-center'
      overlayClassName='fixed inset-0'
      isOpen={isOpen}
      style={{
        content: {
          border: 'none',
          // height: '80vh',
        },
        overlay: {
          zIndex: '99999',
          backgroundColor: 'rgba(0,0,0,0.2)',
        },
      }}
      shouldCloseOnOverlayClick={!showHeader}
    >
      <div className='flex flex-col rounded-lg bg-white w-[343px]'>
        {/** Header */}
        {!showHeader && (
          <div
            className={`flex ${
              !showHeader ? 'flex-row justify-between' : 'flex-row-reverse'
            } p-2 border-b-slate-200 border-b border-solid m-2`}
          >
            {!showHeader && (
              <div
                style={{ fontFamily: 'Inter' }}
                className='text-gray-900 text-base not-italic font-bold leading-6'
              >
                Change Payout Intervals
              </div>
            )}
            <SnapIcon
              icon={'x-solid'}
              color={'#64748B'}
              onClick={toggle}
              className='cursor-pointer'
            />
          </div>
        )}
        {/** Header */}

        {/** Container */}
        {showHeader && (
          <div className='p-2.5'>
            <div className='flex flex-col border border-2 border-green-500 p-4 rounded-[10px]'>
              <div className='flex flex-row justify-center items-center'>
                <svg
                  width='66'
                  height='50'
                  viewBox='0 0 66 50'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M28.8548 29.5156C28.8496 29.312 28.8037 29.1116 28.7198 28.9263C28.6359 28.7411 28.5156 28.5748 28.3664 28.4376L21.4212 22.3087C20.8526 21.7582 20.4039 21.0944 20.1037 20.3596C19.8035 19.6248 19.6584 18.8351 19.6776 18.0407C19.698 16.4048 20.3548 14.8424 21.5067 13.6897C22.6585 12.5371 24.2133 11.8862 25.8364 11.8773H50.5011L60.2693 2.40593C60.4175 2.26209 60.5196 2.07682 60.5625 1.87398C60.6053 1.67114 60.5869 1.46001 60.5097 1.26778C60.4325 1.07556 60.2999 0.911038 60.1291 0.795403C59.9583 0.679769 59.7571 0.618318 59.5513 0.618963H25.0647C24.012 0.619261 23.0003 1.03032 22.2417 1.76597L3.12048 20.3199C-1.80757 25.0999 0.419572 33.001 6.21699 35.0882L27.8682 30.9383C28.173 30.857 28.4393 30.6695 28.6199 30.4091C28.8005 30.1486 28.8837 29.8321 28.8548 29.5156Z'
                    fill='#1269C1'
                  />
                  <path
                    d='M36.8126 21.1723C36.8181 21.371 36.8648 21.5666 36.9499 21.7474C37.035 21.9283 37.1568 22.0906 37.3079 22.2247L44.3811 28.2027C44.9576 28.7412 45.4125 29.39 45.7169 30.1081C46.0213 30.8261 46.1686 31.5977 46.1494 32.3739C46.1286 33.9765 45.4577 35.5067 44.2821 36.6329C43.1065 37.759 41.5208 38.3904 39.8687 38.3903H14.865L4.95856 47.6408C4.80966 47.7817 4.70753 47.9626 4.66524 48.1603C4.62294 48.3579 4.64241 48.5633 4.72114 48.7501C4.79987 48.9369 4.93429 49.0967 5.10719 49.209C5.28008 49.3213 5.48358 49.3809 5.69163 49.3803H40.6613C41.7303 49.3798 42.7577 48.9787 43.5292 48.2607L62.9209 30.1441C67.9138 25.478 65.6551 17.7701 59.7757 15.7518L37.8132 19.8028C37.5087 19.8833 37.2424 20.0639 37.06 20.3136C36.8775 20.5634 36.79 20.867 36.8126 21.1723Z'
                    fill='#15339B'
                  />
                </svg>

                <svg
                  width='65'
                  height='64'
                  viewBox='0 0 65 64'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <rect
                    x='1.59526'
                    y='1'
                    width='61.9993'
                    height='62'
                    rx='30.9997'
                    fill='#6772E5'
                  />
                  <path
                    d='M33.3959 22.5673C31.3237 22.5673 30.0412 23.1635 30.0412 24.7047V24.707C30.0412 29.1473 45.1385 27.0402 45.1385 38.8368C45.1385 45.9444 39.4798 50 31.2708 50C27.5535 49.9824 23.8786 49.2085 20.4698 47.7253V38.3002C23.7807 40.1001 28.0016 41.4524 31.2697 41.4524C33.4859 41.4524 35.0609 40.8809 35.0609 39.0382C35.0609 34.3267 20.0513 36.1019 20.0513 25.1716C20.0513 18.1854 25.4085 14.0016 33.3959 14.0016C36.7584 13.9642 40.0964 14.5773 43.226 15.8072V25.1108C40.1909 23.5122 36.8255 22.6413 33.3959 22.5673Z'
                    fill='white'
                  />
                  <rect
                    x='1.59526'
                    y='1'
                    width='61.9993'
                    height='62'
                    rx='30.9997'
                    stroke='white'
                    strokeWidth='2'
                  />
                </svg>
              </div>
              <p
                style={{ fontFamily: 'Inter' }}
                className='my-2 text-center text-gray-900 text-xl not-italic font-semibold leading-7'
              >
                Thank You for Connecting Your Account
              </p>
              <p
                style={{ fontFamily: 'Inter' }}
                className='text-center text-gray-900 text-base not-italic font-normal leading-6'
              >
                You can now receive funds from Snap! Mobile through your linked
                account.
              </p>
            </div>
          </div>
        )}

        <div className='px-4 mb-3 mt-4'>
          <p
            style={{ fontFamily: 'Inter' }}
            className='text-lg not-italic font-medium leading-7 text-gray-900'
          >
            Snap! Mobile Payout Intervals
          </p>
          <p
            style={{ fontFamily: 'Inter' }}
            className='text-base not-italic font-normal leading-6 mt-1'
          >
            Choose how often you would prefer to receive payouts from Snap!
            Mobile.
          </p>
          <p
            style={{ fontFamily: 'Inter' }}
            className='patext-gray-600 text-sm not-italic font-normal leading-5 my-4'
          >
            <span className='text-red-500'>*</span> Indicates a required field.
          </p>
          <p
            style={{ fontFamily: 'Inter' }}
            className='text-gray-900 text-sm not-italic font-medium leading-5 my-4'
          >
            Select Your Payout Intervals <span className='text-red-500'>*</span>
          </p>

          {computePayoutOptions(stripeEnv).map((option, idx) => {
            return (
              <div className='my-4' key={idx}>
                <input
                  type='radio'
                  checked={payoutInterval === option.name}
                  value={option.name}
                  onChange={(e) => setPayoutInterval(e.target.value)}
                />
                <label className='mx-1 text-sm font-medium'>
                  {option.label}
                </label>
              </div>
            );
          })}
        </div>
        {/** Container */}

        {/** Footer */}
        <div className='flex justify-end xs:justify-center md:justify-end border-t-slate-200 border-t border-solid m-1 p-2'>
          {!showHeader && (
            <div className='w-full pr-1'>
              <SnapButton
                variant='tertiary'
                size='md'
                fullWidth
                onClick={onCancel}
                className='mb-2'
              >
                Cancel
              </SnapButton>
            </div>
          )}
          <div className='w-full pl-1'>
            <SnapButton
              variant='primary'
              size='md'
              fullWidth
              onClick={(): void => {
                if (payoutInterval === undefined) {
                  throw new Error('Payout interval not selected');
                }
                onUpdate(payoutInterval);
              }}
            >
              Update
            </SnapButton>
          </div>
        </div>
        {/** Footer */}
      </div>
    </Modal>
  );
}

export default ChangePayoutIntervalModal;
